import * as React from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import pageStyles from "./styles";
import { Store } from "hooks/main_store";
import LogoFroinBlanco from "../../assets/logos/LogoFroinBlanco.png";

const Footer = React.memo(() => {
  const styles = pageStyles();
  const { state } = useContext(Store);
  const navigate = useNavigate();

  const anchors = [
    { label: "Inicio", view: "/" },
    { label: "Sobre nosotros", view: "/welcome" },
    { label: "Gana en RiffWin", view: "https://riff.win" },
    // { label: "Blog", view: "/blog" },
  ];

  React.useEffect(() => {
    //eslint-disable-next-line
  }, []);

  return (
    <footer>
      <div className={[styles.contFooter, false ? styles.hide : ""].join(" ")}>
        <div className={styles.column}>
          <div
            className={styles.logo}
            onClick={() => {
              navigate("/");
            }}
          >
            <img
              alt="Fravents"
              src={LogoFroinBlanco}
              className={styles.imgLogo}
            />
          </div>
        </div>
        <div className={styles.column}>
          <p className={styles.titleColumn}>Mapa del sitio</p>
          {/* {hideLang ? (
            <></>
          ) : (
            <button
              className={styles.languageSwitcher}
              onClick={onChangeLanguage}
            >
              {i18n.language === "en"
                ? "🇨🇴  Versión Español"
                : "🇺🇸  English version (beta)"}
            </button>
          )} */}
          {anchors.map((anchor) => (
            <a className={styles.link} href={anchor.view} key={anchor.view}>
              {anchor.label}
            </a>
          ))}

          <a className={styles.link} href={"/legal?document=privacy"}>
            Política de Privacidad
          </a>

          <a className={styles.link} href={"/legal?document=terms"}>
            Términos y Condiciones
          </a>
        </div>
        <div className={styles.column}>
          <p className={styles.titleColumn}>Contacto</p>
          {/* <a className={styles.link} href={returnCurrentLink(Routes.FAQ)}>
            {t("components.footer.faq")}
          </a> */}
          {/* <a className={styles.link} href={"/welcome?page=register-artist"}>
            Registrarme como artista
          </a>
          <a className={styles.link} href={"/welcome?page=register-commerce"}>
            Postular mi comercio
          </a> */}
          {/* <a
            className={styles.link}
            href={returnCurrentLink(Routes.PROGRAM_INFO)}
          >
            {t("components.footer.communityFraventsPartners")}
          </a> */}
          <a className={styles.link} href="mailto:hello@froin.co">
            hello@froin.co
          </a>
          <a
            className={styles.link}
            href="https://www.instagram.com/froin.club/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
          {/* <a
            className={styles.link}
            href="https://www.tiktok.com/@fravents"
            target="_blank"
            rel="noopener noreferrer"
          >
            TikTok
          </a> */}
          <a
            className={styles.link}
            href={"https://www.sic.gov.co/"}
            target="blank"
          >
            Ir a la SIC
          </a>
        </div>
      </div>
      <div className={styles.container}>
        FROIN by Favents © 2026 v{state.version}
      </div>
    </footer>
  );
});

export default Footer;
